import React, { useState, useEffect } from 'react';
import historyService from '../services/HistoryService';

const HistoryPage = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const response = await historyService.getHistory();
                setLogs(response.data);
            } catch (err) {
                setError('No se pudo cargar el historial.');
            } finally {
                setLoading(false);
            }
        };
        fetchHistory();
    }, []);

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-3xl font-bold mb-6 text-gray-800">Historial de Reactivaciones</h1>
            <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="py-2 px-4 text-left">Fecha y Hora</th>
                                <th className="py-2 px-4 text-left">Usuario</th>
                                <th className="py-2 px-4 text-left">Cliente</th>
                                <th className="py-2 px-4 text-left">Router</th>
                                <th className="py-2 px-4 text-left">Estado</th>
                                <th className="py-2 px-4 text-left">Detalle</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="6" className="text-center py-4">Cargando...</td></tr>
                            ) : error ? (
                                <tr><td colSpan="6" className="text-center py-4 text-red-500">{error}</td></tr>
                            ) : (
                                logs.map(log => (
                                    <tr key={log.id} className="border-b hover:bg-gray-50">
                                        <td className="py-2 px-4">{new Date(log.fecha_hora_operacion).toLocaleString()}</td>
                                        <td className="py-2 px-4">{log.usuario_que_reactivo}</td>
                                        <td className="py-2 px-4">{log.nombre_cliente} ({log.cedula_cliente})</td>
                                        <td className="py-2 px-4">{log.router_afectado}</td>
                                        <td className="py-2 px-4">
                                            <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                                log.estado_operacion === 'EXITO' ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'
                                            }`}>
                                                {log.estado_operacion}
                                            </span>
                                        </td>
                                        <td className="py-2 px-4 text-sm text-gray-600">{log.mensaje_detalle}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default HistoryPage;
